import { render } from "./ProducerAreaRateForm.vue?vue&type=template&id=d964776e"
import script from "./ProducerAreaRateForm.vue?vue&type=script&lang=js"
export * from "./ProducerAreaRateForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__